import { render, staticRenderFns } from "./returnVisitList.vue?vue&type=template&id=5b9295aa&scoped=true&"
import script from "./returnVisitList.vue?vue&type=script&lang=ts&"
export * from "./returnVisitList.vue?vue&type=script&lang=ts&"
import style0 from "./returnVisitList.vue?vue&type=style&index=0&id=5b9295aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9295aa",
  null
  
)

export default component.exports